import { Box, Button } from "@mui/material";

import { CancelShipmentBookingModal } from "components/CancelShipmentBookingModal";
import { useCarrierShipmentPageContext, useDisclosure } from "hooks";
import { carrierHasBookingWriteAccess } from "utils";

export function CancelShipmentBookingButton() {
  const { shipment, onRefresh } = useCarrierShipmentPageContext();
  const {
    isOpen: cancelShipmentBookingModalOpen,
    onClose: onCloseCancelShipmentBookingModal,
    onOpen: onOpenCancelShipmentBookingModal,
  } = useDisclosure(false);

  if (
    !shipment ||
    !carrierHasBookingWriteAccess(shipment) ||
    shipment.info.type === "MULTI_SHIPMENT_PROJECT" ||
    shipment.shipment_status !== "BOOKED"
  ) {
    return null;
  }

  return (
    <Box>
      <Button
        color="error"
        onClick={onOpenCancelShipmentBookingModal}
        sx={{ mr: "2rem" }}
      >
        Cancel Booking
      </Button>
      <CancelShipmentBookingModal
        onModalClose={onCloseCancelShipmentBookingModal}
        modalOpen={cancelShipmentBookingModalOpen}
        shipmentId={shipment.info.id}
        onBookingCancelledSuccess={onRefresh}
      />
    </Box>
  );
}
